import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const ResendAdminLoginOtpSlice = createSlice({
    name: "resendAdminLoginOtpRequest",
    initialState,
    reducers: {
        resendAdminLoginOtpRequest(state) {
            state.loading = true;
        },
        resendAdminLoginOtpRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        resendAdminLoginOtpRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        resendAdminLoginOtpStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    resendAdminLoginOtpRequest,
    resendAdminLoginOtpRequestSuccess,
    resendAdminLoginOtpRequestError,
    resendAdminLoginOtpStateReset,
} = ResendAdminLoginOtpSlice.actions;

export default ResendAdminLoginOtpSlice.reducer;